import styled, { css } from 'styled-components';
import type { IFadeInUpProps } from '../types';
export const FadeInUp = styled.div<IFadeInUpProps>`
  ${({ inView }) => css`
    ${inView ? css`
      transform: translateY(0rem);
      opacity: 1;
    ` : css`
      transform: translateY(2rem);
      opacity: 0;
    `}
    transition-property: transform, opacity;
    transition-duration: 1.5s;
  `}
  @media (prefers-reduced-motion) {
    transition-duration: 0s !important;
  }
`;
